import { render, staticRenderFns } from "./quotesApplyTerms.vue?vue&type=template&id=dc747a46&"
import script from "./quotesApplyTerms.vue?vue&type=script&lang=js&"
export * from "./quotesApplyTerms.vue?vue&type=script&lang=js&"
import style0 from "./quotesApplyTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "quotesApplyTerms.vue"
export default component.exports